const host = window.location.host

// const host = "crmlte.ipcallgo.com"
console.log("host: ", host);

const dev = {
	API_ENDPOINT_URL:     'https://habitat.ipcall.com.ar/api',
	/* STATIC_ENDPOINT_URL:  'https://localhost:7001/api/static', */
	STATIC_ENDPOINT_URL:  'https://habitat.ipcall.com.ar/api/static',

	GOOGLE_API_CLIENT_ID :'6417990840-6q2k2trjikti5mrst2e5ofllivngc9m9.apps.googleusercontent.com',
	HOST_URL: 'https://'+host,
	HOST: host,

	MAIL_BASE_URL :       "https://mail.ipcall.com.ar/v1",
};

const prod = {
  	API_ENDPOINT_URL:     'https://'+host+'/api',
	STATIC_ENDPOINT_URL:  'https://'+host+'/api/static',

	GOOGLE_API_CLIENT_ID :'6417990840-6q2k2trjikti5mrst2e5ofllivngc9m9.apps.googleusercontent.com',
	HOST_URL: 'https://'+host,
	HOST: host,
	// ----------------------------------------------------
	MAIL_BASE_URL :       "https://mail.ipcall.com.ar/v1"
};


const getEnv = () => {
	switch (process.env.NODE_ENV) {
		case 'development':
			return dev
		case 'production':
			return prod
		default:
			break;
	}
}

export const env = getEnv()